// The stand-in status lines Draft shows while a model is working but nothing
// has streamed yet. The Generate Scenes button and the Muse 2 Alpha comparison
// share the same steps and cadence so the wait reads the same everywhere.
export const DRAFT_PROGRESS_LABELS = Object.freeze([
  "Checking Characters...",
  "Checking Worldbuilding...",
  "Checking Style and Genre...",
  "Checking Synopsis and Outline...",
  "Reviewing Scenes Best Practices...",
  "Ensuring Perfect Formatting...",
]);

export const DRAFT_PROGRESS_LABEL_MS = 4500;

/** Label for `elapsedMs` since the wait began; holds on the last step. */
export function draftProgressLabelAt(elapsedMs, labels = DRAFT_PROGRESS_LABELS) {
  const index = Math.min(labels.length - 1, Math.max(0, Math.floor(elapsedMs / DRAFT_PROGRESS_LABEL_MS)));
  return labels[index];
}
